import { render, staticRenderFns } from "./AddPlain.vue?vue&type=template&id=4d6f822e&scoped=true&"
import script from "./AddPlain.vue?vue&type=script&lang=js&"
export * from "./AddPlain.vue?vue&type=script&lang=js&"
import style0 from "./AddPlain.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./AddPlain.vue?vue&type=style&index=1&id=4d6f822e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f822e",
  null
  
)

export default component.exports